import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import {
    DialogContent,
    DefaultButton,
    PrimaryButton,
    DialogActions,
    DialogContentText,
} from '@bb-ui/react-library';
import CircularProgress from '@material-ui/core/CircularProgress/CircularProgress';
import { Information } from '@bb-ui/icons/dist/small';
import { Banner } from '@bb-ui/react-library/dist/components/Banner';
import { User } from '../../../../../contexts/LicenseManagementContext/LicenseManagementContext.types';
import { useFeatureToggle } from '../../../../../featureFlags/useFeatureToggle';

export const DeleteUserWithNoAssetsDialogContent = (props: {
    userToDelete: User | undefined;
    deleteUser: (_: { user: User }) => void;
    deleteInProgress: boolean;
    closeDialog: () => void;
}) => {
    const { userToDelete, deleteUser, deleteInProgress, closeDialog } = props;
    const { t } = useTranslation();

    const roleManagementEnabled = useFeatureToggle(
        'bbdata.roles.permissions.user.role.management',
    );

    return (
        <>
            <DialogContent
                style={{
                    minHeight: '160px',
                    // top and bottom "margin" the same
                    justifyContent: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <DialogContentText>
                    {t('settings.licenseManagement.delete.innerText', {
                        userName: userToDelete?.userName,
                    })}
                </DialogContentText>
                {!roleManagementEnabled && (
                    <Banner severity="info" icon={<Information />}>
                        { /* prettier-ignore */ }
                        <Trans i18nKey="settings.licenseManagement.delete.bannerText">
                            Make sure to remove <span lang="en">Illuminate</span> roles
                            in <span lang="en">SAML</span> or <span lang="en">Blackboard</span> to
                            deny access to <span lang="en">Illuminate</span>.
                        </Trans>
                    </Banner>
                )}
            </DialogContent>
            <DialogActions>
                <DefaultButton
                    disabled={deleteInProgress === true}
                    data-testid="delete-user-cancel"
                    onClick={closeDialog}
                >
                    {t('settings.licenseManagement.delete.cancel')}
                </DefaultButton>
                <PrimaryButton
                    onClick={() =>
                        deleteUser({
                            user: userToDelete!,
                        })
                    }
                    disabled={deleteInProgress}
                    data-testid="delete-user-confirm"
                >
                    {deleteInProgress ? (
                        <CircularProgress
                            aria-label={t(
                                'settings.licenseManagement.delete.deletionInProgress',
                            )}
                            size={18}
                            data-testid="delete-user-delete-in-progress"
                        />
                    ) : (
                        t('settings.licenseManagement.delete.ok')
                    )}
                </PrimaryButton>
            </DialogActions>
        </>
    );
};
